import type { ReactNode } from 'react';
import React from 'react';
import { cn } from '@skin-seoul/design-system';

type SectionContainerProps = {
  children: ReactNode;
  containerWrapperClassName?: string;
  containerInnerClassName?: string;
  containerInnerStyle?: React.CSSProperties;
};

const SectionContainer = ({
  children,
  containerInnerClassName,
  containerWrapperClassName,
  containerInnerStyle,
}: SectionContainerProps) => {
  return (
    <div className={cn('flex items-center justify-center max-w-[100vw] w-full', containerWrapperClassName)}>
      {/* 1280px + (16px + 16px) Mobile padding */}
      <div
        className={cn(
          'flex flex-col mx-auto max-w-[1280px] px-4 tablet:px-6 desktop:px-10 py-8 tablet:py-18 desktop:py-18 w-full',
          containerInnerClassName,
        )}
        style={containerInnerStyle}
      >
        {children}
      </div>
    </div>
  );
};

export default SectionContainer;
